import aTable from '../../../../../modules/Gull/Framework/aTable.js';
import validation from '../../../../../modules/Gull/Framework/validation.js';

const standaard = {
	init() {
		const target = document.querySelector('body');
		aTable.init(target);

		// Verkrijg stap nummer uit navigatie tabs
		var stap = $('.nav-tabs').data('stap');

		// Initialiseer stappen
		standaard.initProgressBar();

		// Toon submit button bovenaan tabel als er meer dan 20 werknemers in de tabel staan.
		standaard.toggleTopSubmitButton();

		// Toon de introductie modal in stap 1 en fade de loading waarschuwing in en fade de content in en toon de aTable als die aanwezig en geladen is
		standaard.initContent(stap);

		// Toon checkbox "Er zijn in deze periode geen werknemers met een actief dienstverband geweest" wanneer nodig
		standaard.toggleGeenWerknemersInDienst();

		// Javascript t.b.v. stap 7
		if (stap == 7) {
			// Unbind de submit, toon de bevestigingsmodal en bind submit aan de submit modal
			$('form[data-validate]').attr('data-validate-onsubmit-disabled', true);
			$('form[data-validate]').submit(async function () {
				let validated = await validation.checkSubmitForm(this);
				if (validated) {
					$('.modal-naverrekening-indienen').modal('show');
					$('.btn-definitief-indienen').click(function () {
						$('form[data-validate]').unbind('submit');
						$('form[data-validate]').submit();
						$('.modal-naverrekening-indienen').modal('hide');
						$('#loadingModal').modal('show', {
							keyboard: false,
							backdrop: 'static',
						});
					});
				}
				return false;
			});
		}

		// Upload bevestiging
		$('#uploadBevestiging, #importUpload').change(function (e) {
			e.preventDefault();
			standaard.checkImportOk(this);
		});

		// Draai checkSubmitOk validatie functie in stap 2 t/, 6 en normale validatie in stap 1
		switch (stap) {
			case 2:
			case 3:
			case 4:
				$('.btn-import-export-modal').click(function (e) {
					e.preventDefault();
					$('#importExportModal').modal('hide');
					$('#importExportToelichtingModal').modal('show');
				});
				$('.btn-import-export-modal-terug').click(function (e) {
					e.preventDefault();
					$('#importExportToelichtingModal').modal('hide');
					$('#importExportModal').modal('show');
				});
			case 5:
			case 6:
				// Draai checkSubmitOk validatie functie
				$('form#mainForm').submit(standaard.checkSubmitOk);
				break;
			case 1:
			default:
				// Draai normale validatie functie
				$('form#mainForm').submit(validation.submitForm);
				break;
		}

		// Javascript t.b.v. stap 4 en 6
		switch (stap) {
			case 4:
			case 6:
				// Valideer salarisformulier on submit
				$('form[data-validate]#form-salarissen').submit(validation.submitForm);

				// Draai functie als inhoude van tabel geladen is
				// Draai functie als inhoude van tabel geladen is
				$('[data-atable]').on('aTable:draw', function () {
					// Deactiveer click functie op
					$('.open-salaris-modal').unbind('click');

					// Functie om salaris modal te openen met buttons in listing
					$('.open-salaris-modal').click(standaard.openSalarisModal);
				});

				// Submit modal als op opslaan geklikt wordt
				$('#salarisAanpassenModal .btn-success').click(function () {
					$('#salarisAanpassenModal form').submit();
				});

				// Controleer of het salaris al voorkomt
				$('#salarisAanpassenModal #Begindatum').change(standaard.controleerOfSalarisVoorkomt);

				// Toon de importExportModalFeedback modal als hij er is.
				if ($('#importExportModalFeedback').length) {
					$('#importExportModalFeedback').modal('show');
				}

				break;
		}
	},

	// Functie om de stappen te initialiseren
	initProgressBar: function () {
		// Nummer de stappen op basis van aanwezig aantal tabs
		$('.nav-tabs li a b.step-number').each(function (i) {
			$(this).text(i + 1);
		});

		// Tel totaal aantal tabs (stappen) en bereken de breedte van de tabs
		var stepsTotal = $('.sw-main ul.nav-tabs li').length;
		$('.sw-main ul.nav-tabs li').css('width', 'calc((100%)/' + stepsTotal + ')');

		// Fade de tabs in
		$('.sw-main').hide().removeClass('d-none').fadeIn(300);
	},

	// Functie die checkt of er een bestand is geselecteed en de gebruiker akkoord is
	checkImportOk: function (m) {
		var c = $('#uploadBevestiging').prop('checked');
		var u = $('#importUpload');
		var t = $('#buttonImport');
		var f = $('#feedbackCSV');
		var e = u.val().split('.').pop().toLowerCase();
		if (c == true && u[0].files.length == true && e == 'csv') {
			t.removeAttr('disabled');
			f.addClass('d-none').removeClass('d-inline');
		} else {
			t.attr('disabled', true);
			if ($(m).attr('name') == 'importUpload') {
				f.removeClass('d-none').addClass('d-inline');
				if (e != 'csv') {
					u.attr('value', '');
					u.blur();
					setTimeout(function () {
						u.closest('.form-group').find('.file-input-wrapper span').html(u.attr('title'));
					}, 100);
				}
			}
		}
		if (e == 'csv') {
			f.addClass('d-none').removeClass('d-inline');
		}
	},

	// Functie om te stap te valideren voor submit
	checkSubmitOk: function (stap) {
		// Verberg de bevestigingsmodal
		$('.modal-naverrekening-indienen').modal('hide');

		// Verkrijg stap nummer uit navigatie tabs
		stap = $('.nav-tabs').data('stap');

		if (stap == 6) {
			// Check of de checkbox "geen werknemers in dienst" is aangevinkt
			var geenWerknemersInDienst = $('[name=geenWerknemersInDienst]').val();
			if (geenWerknemersInDienst === 'true') {
				return true;
			}
		}

		// Geef waarschuwing als aTable leeg is
		var count = aTable.getRows().length;
		if (count == 0) {
			$('#modalGeenMedewerkers').modal('show');
			return false;
		}

		// Controleer in stap 4 en 6 of er ontbrekende salarissen zijn
		if (stap == 4 || stap == 6) {
			// Tel de ontbrekende salarissen
			var ontbrekendeSalarissen = 0;
			// var rows = document.querySelectorAll('[data-atable]')[0].aTable().getRows();
			var rows = aTable.getRows();
			$.each(rows, function (i, e) {
				if (e[1] == 'danger') {
					ontbrekendeSalarissen++;
				}
			});

			// Toon waarschuwing bij ontbrekende salarissen
			if (ontbrekendeSalarissen > 0) {
				$('#modalSalarisOntbreekt').modal('show');
				$('#modalSalarisOntbreekt #ontbrekendeSalarissen').text(ontbrekendeSalarissen);
				if (ontbrekendeSalarissen > 1) {
					$('#modalSalarisOntbreekt #ontbrekendeSalarissenMeervoud').removeClass('d-none');
				} else {
					$('#modalSalarisOntbreekt #ontbrekendeSalarissenEnkelvoud').removeClass('d-none');
				}
				return false;
			}
		}

		return true;
	},

	// Function om salaris modal te openen
	openSalarisModal: function (e) {
		// Deactiveer default functie van geklikt element
		e.preventDefault();

		// Verberg element d.m.v. bootstrap display none class
		$('#salarisAanpassenModal .salaris-type').removeClass('d-none').addClass('d-none');

		// Geef werknemer ID mee aan modal en input
		var salarisModal = this;
		var werknemer_id = $(this).data('werknemer_id');
		$('#salarisAanpassenModal').data('werknemer_id', werknemer_id);
		$('#salarisAanpassenModal #werknemer_id').val(werknemer_id);

		// Geef werknemer ID mee aan modal en input
		var werknemer_salaris_id = $(this).data('werknemer_salaris_id');
		$('#salarisAanpassenModal').data('werknemer_salaris_id', werknemer_salaris_id);
		$('#salarisAanpassenModal #werknemer_salaris_id').val(werknemer_salaris_id);

		// Toon modal titel en voeg "corrigeren" of "toevoegen" toe als werknemer_salaris_id nog niet bestaat
		$('#salarisAanpassenModal h4').removeClass('d-none').addClass('d-none');
		if (werknemer_salaris_id == '') {
			$('#salarisAanpassenModal h4#salarisAanpassenModalLabelToevoegen').removeClass('d-none');
			$('#salarisAanpassenModal #Begindatum').removeAttr('READONLY');
		} else {
			$('#salarisAanpassenModal h4#salarisAanpassenModalLabelCorrigeren').removeClass('d-none');
			$('#salarisAanpassenModal #Begindatum').attr('READONLY', true);
		}

		// Voeg naam van werknemer toe aan modal titel
		var werknemer_naam = $(this).data('werknemer_naam');
		$('.modal-title .werknemer-naam').html(werknemer_naam);

		// Verkrijg juiste begindatum
		var Begindatum = $(this).data('begindatum');
		var BegindatumDefault = $('#salarisAanpassenModal #Begindatum').data('default');
		var re = /^\d{1,2}-\d{1,2}-\d{4}?$/;
		if (re.test(Begindatum)) {
			var BegindatumSplit = Begindatum.split('-');
			var jaar = parseInt(BegindatumSplit[2]);
			var BegindatumDefaultSplit = BegindatumDefault.split('-');
			var jaarDefault = parseInt(BegindatumDefaultSplit[2]);
			if (jaar < jaarDefault) {
				Begindatum = BegindatumDefault;
			}
		} else {
			Begindatum = BegindatumDefault;
		}
		$('#salarisAanpassenModal #Begindatum').val(Begindatum);

		// Vergrijg de juiste einddatum
		var Einddatum = $(this).data('einddatum');
		var EinddatumDefault = $('#salarisAanpassenModal #Einddatum').data('default');

		// Valideer en formateer de einddatum
		re = /^\d{1,2}-\d{1,2}-\d{4}?$/;
		if (re.test(Einddatum)) {
			var EinddatumSplit = Einddatum.split('-');
			jaar = parseInt(EinddatumSplit[2]);

			var EinddatumDefaultSplit = EinddatumDefault.split('-');
			jaarDefault = parseInt(EinddatumDefaultSplit[2]);
			if (jaar < jaarDefault) {
				Einddatum = EinddatumDefault;
			}
		} else {
			Einddatum = EinddatumDefault;
		}
		$('#salarisAanpassenModal #Einddatum').val(Einddatum);

		// Maak salaris afkorting soort kleine leters
		$('#salarisAanpassenModal .salaris-type').each(function () {
			var type = $(this).data('type');
			$('#salarisAanpassenModal .salaris-type-' + type + ' input').val($(salarisModal).data('salaris_' + type.toLowerCase()));
		});

		// Maak begindatum required
		validation.addRequired($('#salarisAanpassenModal #Begindatum'));
		$('#salarisAanpassenModal #Begindatum').trigger('change');

		// Open salaris modal
		$('#salarisAanpassenModal').modal('show', {
			backdrop: 'static',
			keyboard: false,
		});

		// Haal validatie classes weg na het openen van de modal
		$('#salarisAanpassenModal input,select').each(function () {
			validation.removeValidationClasses(this);
		});
	},

	// Function om te controleren of ingevoerd salaris reeds voorkomt
	controleerOfSalarisVoorkomt: function () {
		if ($('#salarisAanpassenModal #Begindatum').val() != '') {
			var path = $('#salarisAanpassenModal').data('duplicate-check-url');
			$.getJSON(path + $('#salarisAanpassenModal').data('werknemer_id') + '/' + $('#salarisAanpassenModal').data('werknemer_salaris_id') + '/get-types/' + $('#salarisAanpassenModal #Begindatum').val() + '/', function (data) {
				$('#salarisAanpassenModal .salaris-type').removeClass('d-none').addClass('d-none');
				$('#salarisAanpassenModal .salaris-type')
					.find('input')
					.each(function () {
						validation.removeRequired(this);
						$(this).attr('data-minvalue', 0);
					});
				$.each(data, function (index, val) {
					$('#salarisAanpassenModal .salaris-type-' + val).removeClass('d-none');
					$('#salarisAanpassenModal .salaris-type-' + val)
						.find('input')
						.each(function () {
							validation.addRequired(this);
							$(this).attr('data-minvalue', 1);
						});
				});
			});
		}
	},

	// Toon checkbox "Er zijn in deze periode geen werknemers met een actief dienstverband geweest" wanneer nodig
	toggleTopSubmitButton: function () {
		$('[data-atable]').on('aTable:draw', function () {
			var c = aTable.getRows().length;
			var t = $('#geenWerknemersInDienst').closest('.form-group');
			if (c == 0) {
				t.removeClass('d-none');
			} else {
				t.addClass('d-none');
			}
		});
	},

	// Toon submit button bovenaan tabel als er meer dan 20 werknemers in de tabel staan.
	toggleGeenWerknemersInDienst: function () {
		$('[data-atable]').on('aTable:loaded', function () {
			var c = aTable.getRows().length;
			if (c > 20) {
				$('.btn-next-top').removeClass('d-none');
			}
		});
	},

	// Toon de introductie modal in stap 1 en fade de loading waarschuwing in en fade de content in en toon de aTable als die aanwezig en geladen is
	initContent: function (stap) {
		if (stap == 1) {
			$('.modal-naverrekening-introductie').modal('show');
		} else {
			$('.tab-loading').hide().removeClass('d-none').fadeIn(300);
			if ($('[data-atable]').length) {
				$('[data-atable]').on('aTable:loaded', function () {
					$('.tab-loading').fadeOut(100, function () {
						$('.tab-content').hide().removeClass('d-none').fadeIn(300);
					});
				});
			} else {
				$('.tab-loading').fadeOut(100, function () {
					$('.tab-content').hide().removeClass('d-none').fadeIn(300);
				});
			}
		}
	},
};

export default standaard;
